import { ObjectOps, ArrayOps } from '../lift';
/**
 * Creates an Array of all this object's keys, in no particular order.
 */
export function keys() {
    return new ArrayOps(Object.keys(this.value()));
}
ObjectOps.prototype.keys = keys;
